import { createSlice } from '@reduxjs/toolkit';

export const CATALOGUE = 'CATALOGUE';

const initialPaginations = { cataloguePage: 0 };

const slice = createSlice({
  name: 'pagination',
  initialState: initialPaginations,
  reducers: {
    setPagination: (state, { payload }) => {
      switch (payload.action) {
        case CATALOGUE:
          return {
            ...state,
            cataloguePage: payload.data,
          };
        default:
          return { ...state };
      }
    },
    resetPagination: () => ({ ...initialPaginations }),
  },
});

export const { setPagination, resetPagination } = slice.actions;

export default slice.reducer;
